import { SvgIcon } from '@material-ui/core';
import { FC } from 'react';

import { WithStyles, withStyles } from '@core/theme/utils/with-styles';

import { styles } from './Globe.styles';

export interface IconProps extends WithStyles<typeof styles> {
  color?: string;
}

const GlobeIconComponent: FC<IconProps> = ({ classes, color = '#7E8899' }) => {
  return (
    <SvgIcon
      xmlns="http://www.w3.org/2000/svg"
      width="19"
      height="19"
      viewBox="0 0 19 19"
      fill="none"
      classes={{ root: classes.root }}
    >
      <path
        d="M11.6683 1.21646C10.8791 0.968589 10.0393 0.834961 9.16829 0.834961C4.56592 0.834961 0.834961 4.56592 0.834961 9.16829C0.834961 13.7707 4.56592 17.5016 9.16829 17.5016C13.7707 17.5016 17.5016 13.7707 17.5016 9.16829C17.5016 7.73886 17.1417 6.39348 16.5076 5.21783M13.335 3.95996H13.3391M7.91834 17.4085L7.91843 15.5724C7.91843 15.4729 7.95401 15.3768 8.01873 15.3013L10.0902 12.8845C10.2605 12.6859 10.2077 12.3813 9.98059 12.2515L7.60041 10.8914C7.53574 10.8545 7.48216 10.8008 7.44524 10.7362L5.89368 8.01715C5.81293 7.87564 5.65711 7.79418 5.49482 7.80864L0.888447 8.21891M16.6683 4.16829C16.6683 6.00924 15.0016 7.50163 13.335 9.16829C11.6683 7.50163 10.0016 6.00924 10.0016 4.16829C10.0016 2.32735 11.494 0.834961 13.335 0.834961C15.1759 0.834961 16.6683 2.32735 16.6683 4.16829ZM13.5433 3.95996C13.5433 4.07502 13.45 4.16829 13.335 4.16829C13.2199 4.16829 13.1266 4.07502 13.1266 3.95996C13.1266 3.8449 13.2199 3.75163 13.335 3.75163C13.45 3.75163 13.5433 3.8449 13.5433 3.95996Z"
        stroke={color}
        strokeWidth="1.67"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </SvgIcon>
  );
};

export const Globe2Icon = withStyles(styles)(GlobeIconComponent);
